import React from 'react';
import { FileTextIcon, ImageIcon, UsersIcon, GraduationCapIcon, TrendingUpIcon, EyeIcon, CalendarIcon, ArrowUpRightIcon, PlusIcon, PartyPopperIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const AdminDashboard = () => {
  const stats = [{
    label: 'Total Pages',
    value: '35',
    icon: <FileTextIcon size={24} data-id="element-1753" />,
    color: 'bg-blue-500',
    trend: '+2 this week'
  }, {
    label: 'News Articles',
    value: '16',
    icon: <FileTextIcon size={24} data-id="element-1754" />,
    color: 'bg-indigo-500',
    trend: '+1 this week'
  }, {
    label: 'Gallery Images',
    value: '45',
    icon: <ImageIcon size={24} data-id="element-1755" />,
    color: 'bg-purple-500',
    trend: '+5 this week'
  }, {
    label: 'Registered Alumni',
    value: '15,000+',
    icon: <UsersIcon size={24} data-id="element-1756" />,
    color: 'bg-green-500',
    trend: '+120 this month'
  }, {
    label: 'Admission Apps',
    value: '234',
    icon: <GraduationCapIcon size={24} data-id="element-1757" />,
    color: 'bg-yellow-500',
    trend: '+45 this week'
  }, {
    label: 'Site Visitors',
    value: '12,450',
    icon: <EyeIcon size={24} data-id="element-1758" />,
    color: 'bg-red-500',
    trend: '+15% vs last month'
  }];
  const recentActivity = [{
    id: 1,
    action: 'Published new article',
    target: '"Students Rally for 70th Anniversary"',
    time: '2 hours ago',
    user: 'Super Admin'
  }, {
    id: 2,
    action: 'Uploaded 5 images to',
    target: 'Anniversary Gallery',
    time: '5 hours ago',
    user: 'Super Admin'
  }, {
    id: 3,
    action: 'Approved 12',
    target: 'Alumni Registrations',
    time: '1 day ago',
    user: 'Moderator'
  }, {
    id: 4,
    action: 'Updated page content',
    target: 'About Us',
    time: '2 days ago',
    user: 'Editor'
  }, {
    id: 5,
    action: 'Created new event',
    target: 'Inter-House Sports 2026',
    time: '3 days ago',
    user: 'Super Admin'
  }];
  return <div className="space-y-6 animate-fadeIn" data-id="element-1759">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1760">
        <div data-id="element-1761">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1762">
            Dashboard Overview
          </h1>
          <p className="text-sm text-gray-500" data-id="element-1763">
            Welcome back! Here's what's happening on your website today.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-1764">
          <Link to="/admin/content" className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm transition-colors" data-id="element-1765">
            <CalendarIcon size={16} className="mr-2" data-id="element-1766" />
            Content Calendar
          </Link>
          <Link to="/admin/content" className="inline-flex items-center px-4 py-2 bg-blue-950 text-yellow-400 rounded-lg text-sm font-medium hover:bg-blue-900 shadow-sm transition-colors" data-id="element-1767">
            <PlusIcon size={16} className="mr-2" data-id="element-1768" />
            New Post
          </Link>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1769">
        {stats.map((stat, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-1770">
            <div className={`${stat.color} text-white p-3 rounded-lg shadow-sm`} data-id="element-1771">
              {stat.icon}
            </div>
            <div data-id="element-1772">
              <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-1773">
                {stat.label}
              </p>
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1774">
                {stat.value}
              </h3>
              <p className="text-xs font-medium text-green-600 flex items-center" data-id="element-1775">
                <TrendingUpIcon size={12} className="mr-1" data-id="element-1776" />
                {stat.trend}
              </p>
            </div>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1777">
        {/* Chart Placeholder */}
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-1778">
          <div className="flex items-center justify-between mb-6" data-id="element-1779">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-1780">Visitor Trends</h2>
            <select className="text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500" data-id="element-1781">
              <option data-id="element-1782">Last 7 days</option>
              <option data-id="element-1783">Last 30 days</option>
              <option data-id="element-1784">This Year</option>
            </select>
          </div>
          <div className="h-64 bg-gray-50 rounded-lg border border-gray-100 flex items-center justify-center relative overflow-hidden" data-id="element-1785">
            {/* Mock Chart using CSS */}
            <div className="absolute inset-0 flex items-end justify-between px-8 pt-8 pb-4 gap-2" data-id="element-1786">
              {[40, 60, 45, 80, 65, 90, 75].map((height, i) => <div key={i} className="w-full bg-blue-100 rounded-t-sm relative group" data-id="element-1787">
                  <div className="absolute bottom-0 w-full bg-blue-500 rounded-t-sm transition-all duration-1000 ease-out group-hover:bg-blue-600" style={{
                height: `${height}%`
              }} data-id="element-1788"></div>
                </div>)}
            </div>
          </div>
          <div className="flex justify-between px-8 mt-2 text-xs text-gray-500" data-id="element-1789">
            <span data-id="element-1790">Mon</span>
            <span data-id="element-1791">Tue</span>
            <span data-id="element-1792">Wed</span>
            <span data-id="element-1793">Thu</span>
            <span data-id="element-1794">Fri</span>
            <span data-id="element-1795">Sat</span>
            <span data-id="element-1796">Sun</span>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-1797">
          <div className="flex items-center justify-between mb-6" data-id="element-1798">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-1799">Recent Activity</h2>
            <button className="text-sm text-blue-600 hover:text-blue-800 font-medium" data-id="element-1800">
              View All
            </button>
          </div>
          <div className="space-y-6" data-id="element-1801">
            {recentActivity.map(activity => <div key={activity.id} className="flex gap-4" data-id="element-1802">
                <div className="relative mt-1" data-id="element-1803">
                  <div className="w-2 h-2 bg-blue-500 rounded-full ring-4 ring-blue-50" data-id="element-1804"></div>
                  {activity.id !== recentActivity.length && <div className="absolute top-3 left-1 w-px h-full bg-gray-200 -ml-px" data-id="element-1805"></div>}
                </div>
                <div data-id="element-1806">
                  <p className="text-sm text-gray-800" data-id="element-1807">
                    <span className="font-medium" data-id="element-1808">{activity.user}</span>{' '}
                    {activity.action}{' '}
                    <span className="font-medium text-blue-700" data-id="element-1809">
                      {activity.target}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-1810">{activity.time}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-1811">
        <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1812">Quick Actions</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1813">
          <Link to="/admin/content" className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors group" data-id="element-1814">
            <FileTextIcon className="text-gray-400 group-hover:text-blue-600 mb-2" size={24} data-id="element-1815" />
            <h3 className="font-medium text-gray-900 group-hover:text-blue-700" data-id="element-1816">
              Write Article
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1817">
              Publish news or announcements
            </p>
          </Link>
          <Link to="/admin/media" className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors group" data-id="element-1818">
            <ImageIcon className="text-gray-400 group-hover:text-blue-600 mb-2" size={24} data-id="element-1819" />
            <h3 className="font-medium text-gray-900 group-hover:text-blue-700" data-id="element-1820">
              Upload Media
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1821">Add photos to gallery</p>
          </Link>
          <Link to="/admin/anniversary" className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors group" data-id="element-1822">
            <PartyPopperIcon className="text-gray-400 group-hover:text-blue-600 mb-2" size={24} data-id="element-1823" />
            <h3 className="font-medium text-gray-900 group-hover:text-blue-700" data-id="element-1824">
              Anniversary
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1825">
              Manage 70th celebrations
            </p>
          </Link>
          <Link to="/admin/people" className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors group" data-id="element-1826">
            <UsersIcon className="text-gray-400 group-hover:text-blue-600 mb-2" size={24} data-id="element-1827" />
            <h3 className="font-medium text-gray-900 group-hover:text-blue-700" data-id="element-1828">
              Review Admissions
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1829">
              Process new applications
            </p>
          </Link>
        </div>
      </div>
    </div>;
};
export default AdminDashboard;